import React, { Component } from "react"
import axios from "axios"
import { HashRouter as Router, Switch, Route } from "react-router-dom"
import history from "./history"
import CookieConsent from "react-cookie-consent"
import { HashLink as Link } from "react-router-hash-link"
import styled from "styled-components"
import { injectGlobal } from "styled-components"
import Analytics from "react-router-ga"
import "./index.css"

import NavBar from "./components/NavBar"
import Home from "./components/home-page/Home"
import Footer from "./components/Footer"
import PageNotFound from "./components/PageNotFound"
import {
  News,
  SingleArticle,
  Games,
  Publishing,
  Jobs,
  Company,
  ManEater,
  Espire1,
  Espire2,
  RO2,
  KillingFloorIncursion,
  KillingFloor,
  RedOrchestra,
  RisingStorm,
  TheBall,
  ZenoClash,
  Dwarfs,
  VideoPolicy,
  EndUserLicenseAgreement,
  PrivacyNotice,
  Cookies,
  Signup,
} from "./LazyLoading"

injectGlobal`
@import url('https://fonts.googleapis.com/css?family=Titillium+Web');
`

class App extends Component {
  state = {
    surveyLink: "",
  }

  componentDidMount() {
    this.getSurveyLink()
  }

  getSurveyLink = async () => {
    try {
      const res = await axios.get(
        "https://api.cosmicjs.com/v3/buckets/tripwireinteractivecom-tripwire-company-site/objects/64e76f5e513ef413daf66153?read_key=6g2KCi7qzTuEkWMEQB6ZDP5v7ZhY7STGFpUPn6lkBpiFEpnqyw&depth=1&props="
      )
      const surveyLink = res.data.object["metadata"].survey_url
      this.setState({ surveyLink })
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    return (
      <Router history={history}>
        <WideScreenStyle>
          <WebsiteLayout>
            <NavBar />
            <Body>
              <Analytics id="UA-384258-2" debug>
                <CookieConsent style={{ background: "rgba(0, 0, 0, 0.9)" }}>
                  <p>
                    This website uses cookies (biscuits) to enhance the user
                    experience. By clicking "I understand" or continuing to use
                    our site, you acknowledge that you accept our{" "}
                    <Link to="/privacy-notice/#top" className="grey-text">
                      Privacy Notice
                    </Link>
                    .
                  </p>
                </CookieConsent>
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/news" component={News} />
                  <Route exact path="/news/:id" component={SingleArticle} />
                  <Route path="/games" component={Games} />
                  <Route
                    path="/killing-floor-2-survey"
                    component={() =>
                      (window.location = `${this.state.surveyLink}`)
                    }
                  />
                  <Route path="/company" component={Company} />
                  <Route
                    path="/killing-floor-2"
                    component={() =>
                      (window.location = "https://killingfloor2.com/")
                    }
                  />
                  <Route
                    path="/killing-floor-double-feature"
                    component={() =>
                      (window.location =
                        "https://killingfloor2.com/killingfloordoublefeature/")
                    }
                  />
                  <Route
                    path="/rising-storm-2-vietnam"
                    component={() =>
                      (window.location = "http://www.risingstorm2.com/")
                    }
                  />
                  <Route
                    path="/road-redemption"
                    component={() =>
                      (window.location =
                        "http://roadredemption.tripwireinteractive.com/")
                    }
                  />
                  <Route
                    path="/chivalry-ii"
                    component={() =>
                      (window.location = "https://chivalry2.com/")
                    }
                  />
                  <Route path="/maneater" component={ManEater} />
                  <Route
                    path="/deceive-inc"
                    component={() =>
                      (window.location = "https://deceiveinc.com/")
                    }
                  />
                  <Route
                    path="/deceive"
                    component={() =>
                      (window.location = "https://deceiveinc.com/")
                    }
                  />
                  <Route path="/espire-1-vr-operative" component={Espire1} />
                  <Route path="/espire-2" component={Espire2} />
                  <Route path="/ro-2-heroes-of-stalingrad" component={RO2} />
                  <Route
                    path="/killing-floor-incursion"
                    component={KillingFloorIncursion}
                  />
                  <Route path="/killing-floor" component={KillingFloor} />
                  <Route
                    path="/red-orchestra-ostfront-41-45"
                    component={RedOrchestra}
                  />
                  <Route path="/rising-storm" component={RisingStorm} />
                  <Route path="/the-ball-game" component={TheBall} />
                  <Route path="/zeno-clash-game" component={ZenoClash} />
                  <Route path="/dwarfs-game" component={Dwarfs} />
                  <Route
                    path="/gameplay-and-related-videos-policy"
                    component={VideoPolicy}
                  />
                  <Route
                    path="/standard-end-user-license-agreement"
                    component={EndUserLicenseAgreement}
                  />
                  <Route path="/privacy-notice" component={PrivacyNotice} />
                  <Route path="/cookies-policy" component={Cookies} />
                  <Route exact path="/careers" component={Jobs} />
                  <Route path="/publishing" component={Publishing} />
                  <Route path="/signup" component={Signup} />
                  <Route component={PageNotFound} />
                </Switch>
              </Analytics>
            </Body>
            <Footer />
          </WebsiteLayout>
        </WideScreenStyle>
      </Router>
    )
  }
}

export default App

const WideScreenStyle = styled.div`
  background: #1f1f1f;
`

const WebsiteLayout = styled.div`
  max-width: 1920px;
  margin: auto;

  button {
    border: solid;
    border-width: 1px;
    border-color: #fde704;
    box-shadow: 0 5px 5px -3px black;
  }

  button:hover {
    cursor: pointer;
  }

  a {
    color: white;
  }

  a.grey-text {
    color: #fde704;
  }

  a:hover {
    color: #fde704;
  }

  h1,
  h3 {
    font-family: "BICUBIK", sans-serif;
    text-shadow: 2px 2px black;
  }

  h1 {
    letter-spacing: 4px;
    padding: 0 10px;
  }

  h2 {
    font-family: "Titillium Web", sans-serif;
    font-size: 24px;
    letter-spacing: 3px;
  }

  h3 {
    font-size: 18px;
    letter-spacing: 2px;
  }

  h4,
  h5,
  a,
  p,
  li {
    font-family: "Titillium Web", sans-serif;
    letter-spacing: 1px;
  }

  p,
  li {
    text-shadow: 1px 1px black;
  }

  li {
    line-height: 1.5;
  }

  @media (max-width: 650px) {
    h1,
    h2 {
      letter-spacing: 2px;
    }

    h2 {
      font-size: 21px;
    }
  }
`

const Body = styled.div`
  margin-top: 116px;

  @media (max-width: 1200px) {
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/App.js